module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "CopyrightPage",
      "title": "Copyright Page"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "imagecenter"
  }, [_c('img', {
    attrs: {
      "alt": "CGI Irion Books LLC Logo",
      "id": "CopyrightLogo",
      "src": "Images/logo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © February 2011 by Charles G. Irion trustee C.I. Trust, Summit Murders LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eBook Edition 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eBook ISBN: 9780982598672")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Trade Paperback ISBN: 9780984161836")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of the publisher, except in case of brief quotations embodied in critical articles and reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('strong', [_vm._v("eBook Edition, License Notes")]), _c('br'), _vm._v("\n  This ebook is licensed for your personal enjoyment only. This ebook may not be re-sold or given away to other people. If you would like to share this book with another person, please purchase an additional copy for each person you share it with. If you're reading this book and did not purchase it, or it was not purchased for your use only, then you should return to Smashwords.com and purchase your own copy. Thank you for respecting the hard work of this author.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Cover Design by Johnny Miguel, "), _c('a', {
    attrs: {
      "href": "http://www.johnnymiguel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.johnnymiguel.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Book illustrations by Jason Crye")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("eBook Design by Rickhardt Capidamonte")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Irion Books"), _c('br'), _vm._v("\n  480-699-0068"), _c('br'), _vm._v("\n  4462 E. Horseshoe Rd."), _c('br'), _vm._v("\n  Phoenix, Arizona 85028"), _c('br'), _vm._v("\n  email: "), _c('a', {
    attrs: {
      "href": "mailto:charles@charlesirion.com"
    }
  }, [_vm._v("charles@charlesirion.com")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.IrionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.IrionBooks.com")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.SummitMurderMystery.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SummitMurderMystery.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Digital Editions produced by: "), _c('a', {
    attrs: {
      "href": "http://www.booknook.biz",
      "target": "_blank"
    }
  }, [_vm._v("BookNook.biz")]), _vm._v("."), _c('br'), _vm._v("\n  Email us: "), _c('a', {
    attrs: {
      "href": "mailto:hitch@booknook.biz"
    }
  }, [_vm._v("hitch@booknook.biz")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c7197f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/CopyrightPage.vue
// module id = 66
// module chunks = 0